/*=========================================================================================
  File Name: moduleStatusMobileState.js
  Description: Status Mobiles Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	statusMobile: [],
	status: [],
	companies: [],
	statusOnly: [],
};
